import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CollectibleCard"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/editor/[id]/(settings)/publish/components/CollectibleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/editor/[id]/(settings)/publish/components/PostCardContentClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostEditProvider"] */ "/vercel/path0/packages/nextjs/app/contexts/PostEditContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/packages/nextjs/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/vercel/path0/packages/nextjs/components/ui/tabs.tsx");
